import {getHighValueDeductions} from 'src/appApi';
import {SET_HIGH_VALUE_DEDUCTIONS} from '../actionNames';
import {setAppState} from '../app/app.actions';
import {AppReducerStates, NotificationType} from '../app/app.reducer';
import {parseSingleTransaction} from '../transactions/transactions.utils';
import {HighValueDeductionStateType} from './highValueDeductions.reducer';

const setHighValueDeductions = (
  payload: Pick<HighValueDeductionStateType, 'deductions'>,
) => {
  return {
    type: SET_HIGH_VALUE_DEDUCTIONS,
    payload,
  };
};

export const fetchHighValueDeductions = (user_id: number, year: number) => {
  return async (dispatch: any) => {
    try {
      const {data} = await getHighValueDeductions({
        user_id,
        app_year: year,
      });
      const deductions = data.map((backendTxn) =>
        parseSingleTransaction(backendTxn),
      );
      dispatch(setHighValueDeductions({deductions}));
    } catch (e) {
      dispatch(
        setAppState(AppReducerStates.notifcationStatus, {
          isVisible: true,
          message: `Failed to fetch high value deductions (${e})`,
          type: NotificationType.error,
        }),
      );
    }
  };
};
